import { createContext } from 'react'

/**
 * The DOM node in a tile's header where the body renderer's controls are shown.
 *
 * Every tile has ONE header row: title on the left, controls on the right. The
 * card frame (TileCard / ExpandedTile) owns the header and exposes this slot;
 * each renderer (charts, maps, tables) keeps owning its own controls but renders
 * them into the slot via <HeaderControls>, so they land on the title row instead
 * of a second row inside the body.
 *
 * Kept in its own module (no component export) so react-refresh stays happy.
 */
export const TileHeaderSlot = createContext<HTMLElement | null>(null)
